import { useContext, useEffect } from 'react';
import { classes } from 'typestyle'
import { Box } from '../../__aeki__/components/box/box.component'
import { Button } from '../../__aeki__/components/button'

/* Context ====================================================================================== */
import { NavigationContext } from '../../__aeki__/contexts/navigation'

/* Core ========================================================================================= */
import { addSnippet } from '../../__aeki__/core/snippet-manager'

/* Hooks ======================================================================================== */
import useFetch from '../../__aeki__/hooks/use-fetch'

/* Components =================================================================================== */
import { Snippet, SnippetHead, SnippetBody } from '../../__aeki__/modules/layouts/snippet'

/* Styles ======================================================================================= */
import { mt8 } from '../../__aeki__/styles/styleset/margin/mt8'

export default addSnippet('ComminityChildcareOpeningsActions', (props: any) => {
  const { title, sync } = props
  const { navigation, layout, schema } = useContext(NavigationContext)

  const apiUrl = `${process.env.REACT_APP_API_URL}/a/snippets/community-childcare-openings-actions`
  const [data, $data] = useFetch({}, { url: apiUrl })

  useEffect(() => {
    if (data.mounted) {
      // $data.get()
    }
  }, [data.mounted])

  return (
    <Snippet>
      <SnippetHead title={title} />
      <SnippetBody>
        <Box>
          <Button label="Import CSV File" baseline="primary" square size="sm" onClick={sync} />
          <Button
            className={mt8}
            label="Download Exel Template"
            baseline="background"
            square
            size="sm"
          />
          <Button
            className={mt8}
            label="Remove All Openings"
            baseline="background"
            square
            size="sm"
          />
        </Box>
      </SnippetBody>
    </Snippet>
  )
})
